<template>
  <div>
    <CatalogTable
      md-fixed-header
      :propsToSearch="propsToSearch"
      :tableData="highwayCompanies"
      :tableHeaders="obb"
      :tableFilters="customerFilters"
      :actions="customerActions"
      :pageSize="100"
      hidePageSize
      hideFooter
    >
      <template slot="search-toolbar-actions">
        <md-button
          v-if="$can('add', 'Highway', 'highwaycompany')"
          class="md-success"
          @click="prepareCreate"
        >
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </CatalogTable>
    <editModal
      v-if="classicModal"
      :editedItem="item"
      @close="classicModalHide"
      @saved="updateElement"
      @error="classicModalHide"
    >
      <template slot="header">
        <h4 v-if="isRegister" class="modal-title">Agregar compañia carretera</h4>
        <h4 v-else class="modal-title">Editar compañia carretera</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="classicModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
    </editModal>
  </div>
</template>

<script>
import { CatalogTable } from "@/components";
import dataService from "../../../services/catalog";
import { booleanToState } from "@/filters";
import editModal from "./editModal";

export default {
  components: {
    CatalogTable,
    editModal,
  },
  data() {
    return {
      highwayCompanies: [],
      // Items
      item: {},

      // table props
      tableData: [],
      propsToSearch: ["name", "codeName", "shortName"],
      footerTable: [
        "Nombre Codigo",
        "Nombre",
        "Nombre Corto",
        "Estado",
        "Acciones",
      ],
      obb: {
        codeName: "Nombre Codigo",
        name: "Nombre",
        shortName: "Nombre Corto",
        // isActive:'Estado',
      },
      customerFilters: {
        isActive: booleanToState,
      },
      customerActions: [
        {
          icon: "edit",
          exe: this.prepareEdit, // Table return C is element selected
          showIf: () => this.$can("change", "Highway", "highwaycompany"),
        },
        {
          icon: "delete",
          exe: this.deleteItem,
          showIf: () => this.$can("delete", "Highway", "highwaycompany"),
        },
      ],

      // Modal
      classicModal: false,
      isRegister: false,
    };
  },
  methods: {
    // Modal
    classicModalHide() {
      this.classicModal = false;
    },

    // Operations CRUD
    prepareEdit(c) {
      // get element selected from table
      this.item = c; // make copy of element selected
      this.isRegister = false; // Modal in mode edition
      this.classicModal = true; // show modal
    },
    prepareCreate() {
      this.isRegister = true;
      this.item = { logo: null };
      this.classicModal = true;
    },

    updateElement({ original, updated }) {
      // excecute when the form is valid
      this.classicModalHide();
      if (!original.id) {
        this.createdE(updated);
      } else {
        this.editElement(updated, original);
      }
    },

    // CRUD Services
    createdE(h) {
      dataService
        .create("highwaycompany", h, { source: this.highwayCompanies })
        .then((highwaycompany) =>
          this.$successMessage({
            title: `Crear Compania Carretera: ${highwaycompany.name}`,
          })
        )
        .catch(this.$fireErrorResponse);
    },

    editElement(updated, original) {
      dataService
        .update("highwaycompany", updated, original, {
          source: this.highwayCompanies,
        })
        .then(
          (h) => this.$successMessage({ title: `${h.name} fue Editado` }),
          this.$fireErrorResponse
        );
    },

    consultElement() {
      dataService
        .fetch("highwaycompany")
        .then((highwayCompanies) => (this.highwayCompanies = highwayCompanies))
        .catch(this.$fireErrorResponse);
    },

    deleteItem(c) {
      this.$confirmMessage({ title: "¿Estas seguro?" }, () => {
        return dataService
          .delete("highwaycompany", c, { source: this.highwayCompanies })
          .then(() =>
            this.$successMessage({
              title: "Borrado",
              text: "Se ha borrado el registro",
            })
          )
          .catch(this.$fireErrorResponse);
      });
    },
  },

  mounted() {
    this.consultElement();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Highwaycompany/index.vue